import React from 'react'
import { Router } from '@reach/router'
import Account from './Account'

function Administration(props) {
  return (
    <Router>
      <Account path="account/*" />
    </Router>
  )
}

export default Administration
